import {makeObservable, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";

export class AppBolaoDisplayModel extends BaseWidgetDisplayModel {
  @observable isVisible: Boolean;
  @observable isNavigationsVisible: Boolean;
  @observable isFloatingVisible: Boolean;

  constructor() {
    super();

    makeObservable(this);
  }
}
